require("@local/core/src/index.js");
